import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const nurseryRejectionWhatToDo: BlogMetaData = {
  title: '保育園落ちた…2027年4月入園に向けて今すぐできる7つの選択肢',
  description:
    '保育園落ちた…まず、その気持ちは自然です。不承諾通知のあとに今日やる確認事項から、二次募集・認可外・育休延長など7つの選択肢、後悔しない意思決定3ステップまで、モンテッソーリ園長20年以上の視点でお伝えします。',
  thumbnailUrl: '/img/blog-nursery-rejection-what-to-do.webp',
  filePath: buildBlogFilePath('nursery-rejection-what-to-do'),
  category: BLOG_CATEGORY.NURSERY,
};
